import GravityV3Adapter from 'teacher-ui-client/adapters/gravity/v3-adapter'

export default class SubscriptionCoordinatorAdapter extends GravityV3Adapter {}
